import React from 'react'
import { useExportTLPPoints, useGetTLPPoints } from '../../api/point'
import { PointPanelScreen } from '../shared/PointPanelScreen'
import { LUBRICANT } from '../shared/companies'

export const TLPPoints = () => {
  const columns = [
    { id: 'companyAccountId', label: 'Company Id' },
    { id: 'companyName', label: 'Company Name' },
    { id: 'earnedPoints', label: 'Earned Points' },
    { id: 'spentPoints', label: 'Spent Points' },
    { id: 'point', label: 'Total Points' },
    { id: 'salesId', label: 'Sales Id' },
  ]

  return (
    <PointPanelScreen
      title='Mobil TLP Point'
      htgCompany={LUBRICANT}
      useExportApi={useExportTLPPoints}
      useGetPoints={useGetTLPPoints}
      columns={columns}
      linkBase='tlp-summary'
    />
  )
}
